import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TKhattabatMessage } from "../../Types";
import { post } from "../axios-post";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat101MatchStore from "../../stores/khattabat-stores/101m-stores";

export const apiCallGetOneOOneMMessages = async ({
  matchID
}: {
  matchID: number;
}): Promise<{
  data: {
    oneOOneMMessages: TKhattabatMessage[];
    oneOOneMComments: TKhattabatMessage[];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const alKhattabaUUID = getKhattabatStore().alkhattabaUUID.get();

  const userUUID = getKhattabat101MatchStore(matchID).matchUUID.get();

  const { status, data, et3Error } = await post<{
    oneOOneMMessages: TKhattabatMessage[];
    oneOOneMComments: TKhattabatMessage[];
  }>(`khattabat/getOneOOneMMessages`, {
    alkhattabaUUID: alKhattabaUUID,
    clientUUID: userUUID
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { oneOOneMMessages: [], oneOOneMComments: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { oneOOneMMessages: [], oneOOneMComments: [] },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
